import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["togglable"]

  toggle() {
    this.togglableTargets.forEach(tt => (tt.hidden = !tt.hidden))
  }
}
